export const UNRESOLVED_STATUSES = [
  "pending",
  "needs_review",
  "conflict",
  "proposed",
  "rejected",
] as const;

export type UnresolvedStatus = (typeof UNRESOLVED_STATUSES)[number];

export const RAW_MATCH_STATUSES = [
  "matched",
  "missing_trr",
  "missing_pdf",
  "missing_both",
  "ambiguous",
] as const;

export const CELL_STATUSES = [
  "valid",
  "conflict",
  "missing",
  "manual",
] as const;
